import React from "react";
import Select from "react-select";

// const options = [
//   { value: { id: 1, name: "roy" }, label: "Roy" },
//   { value: { id: 2, name: "Tom" }, label: "Tom" },
// ];
const customStyles = {
  control: (base, state) => ({
  ...base,
  minHeight: 36,
  borderRadius: 10,
  border: `1px solid ${state.isFocused ? "#0f9d8a" : "#0f9d8a"}`,
  boxShadow: "none",
  "&:hover": { borderColor: "#0f9d8a" },
  ":active": {
    borderColor: "#0f9d8a",
    boxShadow: "0 0 0 1px #0f9d8a"
  }
}),

  valueContainer: (base) => ({
    ...base,
    height: 36,
    padding: "0 12px",
    display: "flex",
    alignItems: "center",           // ✅ vertical centering
  }),
singleValue: (base) => ({
  ...base,
  color: "black",
}),

option: (base, state) => ({
  ...base,
  backgroundColor: state.isSelected
    ? "#0f9d8a"
    : state.isFocused || state.isActive
    ? "#e6f7f4"
    : "#fff",
  color: state.isSelected ? "#fff" : "#000",
  cursor: "pointer",
  ":active": {
    backgroundColor: "#0f9d8a",
    color: "#fff"
  }
}),


  menu: base => ({
    ...base,
    borderRadius: 10,
    overflow: "hidden",
    zIndex: 9999
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 })
};

class SelectBoxSearch extends React.Component {
  state = {
    selectedOption: "",
  };

   componentDidMount() {
    this.setState({
      selectedOption: this.props.selectedUser|| null,
    });
   }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedUser !== this.props.selectedUser ||
      prevProps.options !== this.props.options
    ) {
      this.updateSelectedOption(this.props);
    }
  }
    updateSelectedOption = (props) => {
    const { selectedUser, options } = props;

    if (selectedUser) {
  const matched = options.find((opt) => opt.value === selectedUser.value);
  this.setState({ selectedOption: matched || null });
} else {
  this.setState({ selectedOption: null });
}
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.onChange) {
    this.props.onChange(selectedOption);
    }
  };

  render() {
    const { selectedOption } = this.state;
    const { options } = this.props;
    return (
      <Select
        value={selectedOption || null}  
        styles={customStyles}
        onChange={this.handleChange}
        options={options}
        placeholder={<div>Select...</div>}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
      />
    );
  }
}

export default SelectBoxSearch;